//第一位 9 h5壳与sdk通讯段
//第二位 2 通知sdk/3 被sdk通知
//第三位 1 数据处理/2 执行行为/3 通知性质
//第四五位 code位
export enum ACTION_CODE {
    // 通知隐私协议结果
    POST_PAGREE = 92301,
    // 打开侧边栏
    POST_SIDER = 92201,
    // 通知confirm结果
    POST_CONFIRM = 92302,
    // 公告关闭
    POST_ANNOUNCEMENT = 92303,

    POST_ACCOUNTDATA = 92304,

    POST_AGREE_STATUS = 92305
}
export enum LISTENER_CODE {
    //打开隐私协议界面
    OPEN_PAGREE = 93201,
    //打开防沉迷提示页面
    OPEN_FCM = 93202,
    //消息提示x
    OPEN_TIP = 93203
}


//行为，数据
export const callApp = (action:number,data:object={})=>{
    //获取iframe节点
    let iframe = document.getElementById('lvanIframe') as HTMLIFrameElement;
    if(iframe){
        //组装数据
        let _data = `${action}?${window.btoa(JSON.stringify(data))}`
        console.log("_____________data=============>", _data)
        iframe?.contentWindow?.postMessage(_data,'*');
    }else{
        //入池
    }
}